import gql from 'graphql-tag';

export const documentAttachmentsQuery = gql`
  query Document {
    document {
      id
      documentAttachments {
        id
        requireView
        previewUrl
        lastView
        lastUpload
        attachment {
          id
          attachmentTitle
          attachmentDescription
          attachmentType
          attachmentUrl
          attachmentFilename
        }
      }
    }
  }
`;
